export const projectsTranslations = {
  en: {
    // Main projects page
    'projects.title': 'Our Projects',
    'projects.subtitle': 'Explore our portfolio of successful construction projects that showcase our expertise and commitment to excellence.',
    
    // Search and filters
    'projects.search.placeholder': 'Search projects...',
    'projects.filters.all': 'All Projects',
    'projects.filters.allSectors': 'All Sectors',
    'projects.filters.allCities': 'All Cities',
    'projects.filters.allYears': 'All Years',
    'projects.filters.commercial': 'Commercial',
    'projects.filters.entertainment': 'Entertainment',
    'projects.filters.hotel': 'Hotel',
    'projects.filters.industrial': 'Industrial',
    'projects.filters.residential': 'Residential',
    'projects.filters.education': 'Education',
    'projects.filters.utilities': 'Utilities',
    'projects.filters.warehouse': 'Warehouse',
    'projects.filters.infrastructure': 'Infrastructure',
    'projects.filters.renovation': 'Renovation',
    'projects.filters.active': 'Active',
    'projects.filters.planning': 'Planning',
    'projects.filters.completed': 'Completed',
    'projects.filters.onHold': 'On Hold',
    
    // Cities
    'projects.cities.jeddah': 'Jeddah',
    'projects.cities.makkah': 'Makkah',
    'projects.cities.jizan': 'Jizan',
    'projects.cities.taif': 'Taif',
    'projects.cities.alUla': 'Al Ula',
    'projects.cities.khobar': 'Khobar',
    'projects.cities.alAhsa': 'Al Ahsa',
    'projects.cities.dammam': 'Dammam',
    'projects.cities.neom': 'Neom',
    'projects.cities.madinah': 'Madinah',
    'projects.cities.hael': 'Hael',
    'projects.cities.kaec': 'KAEC',
    'projects.cities.wadiAlDawaser': 'Wadi Al Dawaser',
    'projects.cities.yanbu': 'Yanbu',
    'projects.cities.riyadh': 'Riyadh',
    
    // Status
    'projects.status.active': 'Active',
    'projects.status.planning': 'Planning',
    'projects.status.completed': 'Completed',
    'projects.status.on-hold': 'On Hold',
    
    // Form
    'projects.form.selectCity': 'Select City',
    'projects.form.selectSector': 'Select Sector',
    'projects.form.selectStatus': 'Select Status',
    'projects.form.selectYear': 'Select Year',
    'projects.form.selectScopeOfWork': 'Select Scope of Work',
    'projects.form.scopeOfWork': 'Scope of Work',
    'projects.form.progress': 'Progress',
    'projects.form.placeholder.progress': 'Enter progress percentage (0-100)',
    'projects.form.projectName': 'Project Name',
    'projects.form.projectNameAr': 'Project Name (Arabic)',
    'projects.form.placeholder.projectName': 'Enter project name',
    'projects.form.placeholder.projectNameAr': 'أدخل اسم المشروع',
    
    // SEO Fields
    'projects.form.slug': 'URL Slug',
    'projects.form.placeholder.slug': 'project-url-slug',
    'projects.form.metaTitle': 'SEO Title',
    'projects.form.metaTitleAr': 'SEO Title (Arabic)',
    'projects.form.placeholder.metaTitle': 'Enter SEO title (max 60 characters)',
    'projects.form.placeholder.metaTitleAr': 'أدخل عنوان SEO (حد أقصى 60 حرف)',
    'projects.form.metaDescription': 'SEO Description',
    'projects.form.metaDescriptionAr': 'SEO Description (Arabic)',
    'projects.form.placeholder.metaDescription': 'Enter SEO description (max 160 characters)',
    'projects.form.placeholder.metaDescriptionAr': 'أدخل وصف SEO (حد أقصى 160 حرف)',
    'projects.form.metaKeywords': 'SEO Keywords',
    'projects.form.metaKeywordsAr': 'SEO Keywords (Arabic)',
    'projects.form.placeholder.metaKeywords': 'Enter keywords separated by commas',
    'projects.form.placeholder.metaKeywordsAr': 'أدخل الكلمات المفتاحية مفصولة بفواصل',
    
    // Scope of Work
    'projects.scope.mepWorks': 'MEP Works',
    'projects.scope.civilMepWorks': 'Civil & MEP Works',
    
    // Table headers
    'projects.table.progress': 'Progress',
    'projects.table.scopeOfWork': 'Scope of Work',
    'projects.table.featuredPhoto': 'Featured Photo',
    'projects.table.actions': 'Actions',
    
    // Dashboard stats
    'dashboard.activeProjects': 'Active Projects',
    'dashboard.completedProjects': 'Completed Projects',
    
    // Project labels
    'projects.labels.location': 'Location',
    'projects.labels.size': 'Size',
    'projects.labels.value': 'Value',
    'projects.labels.keyFeatures': 'Key Features',
    'projects.viewDetails': 'View Details',
    
    // No results
    'projects.noResults.title': 'No Projects Found',
    'projects.noResults.message': 'Try adjusting your search criteria or filters to find more projects.',
    'projects.noResults.clearFilters': 'Clear All Filters',
    
    // Stats section
    'projects.stats.title': 'Project Statistics',
    'projects.stats.subtitle': 'Our track record speaks for itself',
    'projects.stats.completed': 'Projects Completed',
    'projects.stats.value': 'Total Value',
    'projects.stats.satisfaction': 'Client Satisfaction',
    'projects.stats.experience': 'Years Experience',
    
    // CTA section
    'projects.cta.title': 'Ready to Start Your Project?',
    'projects.cta.subtitle': 'Let\'s discuss how we can bring your vision to life with the same quality and expertise shown in our portfolio.',
    'projects.cta.button1': 'Get Free Quote',
    'projects.cta.button2': 'Contact Us',
    
    // Downtown Office Complex
    'projects.downtown.title': 'Downtown Office Complex',
    'projects.downtown.description': 'Modern 25-story office building with sustainable design and smart building technology.',
    'projects.downtown.location': 'Downtown Business District',
    'projects.downtown.feature1': 'LEED Gold Certified',
    'projects.downtown.feature2': 'Smart Building Systems',
    'projects.downtown.feature3': 'Green Roof Design',
    'projects.downtown.feature4': 'Advanced Security',
    
    // Luxury Residential Tower
    'projects.luxury.title': 'Luxury Residential Tower',
    'projects.luxury.description': 'Premium 40-story residential development with world-class amenities and stunning views.',
    'projects.luxury.location': 'Waterfront District',
    'projects.luxury.feature1': 'Penthouse Suites',
    'projects.luxury.feature2': 'Rooftop Pool',
    'projects.luxury.feature3': 'Concierge Service',
    'projects.luxury.feature4': 'Private Gardens',
    
    // Highway Bridge Project
    'projects.bridge.title': 'Highway Bridge Project',
    'projects.bridge.description': 'Major infrastructure project connecting two major highways with innovative engineering solutions.',
    'projects.bridge.location': 'Metropolitan Area',
    'projects.bridge.feature1': 'Advanced Engineering',
    'projects.bridge.feature2': 'Seismic Resistant',
    'projects.bridge.feature3': 'Smart Traffic Systems',
    'projects.bridge.feature4': 'Environmental Impact',
    
    // Historic Building Renovation
    'projects.historic.title': 'Historic Building Renovation',
    'projects.historic.description': 'Preservation and modernization of a century-old landmark building for contemporary use.',
    'projects.historic.location': 'Historic District',
    'projects.historic.feature1': 'Heritage Preservation',
    'projects.historic.feature2': 'Modern Amenities',
    'projects.historic.feature3': 'Energy Efficiency',
    'projects.historic.feature4': 'Cultural Center',
    
    // Shopping Mall Development
    'projects.shopping.title': 'Shopping Mall Development',
    'projects.shopping.description': 'Large-scale retail complex with entertainment facilities and modern shopping experience.',
    'projects.shopping.location': 'Suburban Area',
    'projects.shopping.feature1': 'Multi-Level Design',
    'projects.shopping.feature2': 'Entertainment Zone',
    'projects.shopping.feature3': 'Food Court',
    'projects.shopping.feature4': 'Parking Complex',
    
    // Eco-Friendly Community
    'projects.eco.title': 'Eco-Friendly Community',
    'projects.eco.description': 'Sustainable residential community with green building practices and renewable energy systems.',
    'projects.eco.location': 'Green Valley',
    'projects.eco.feature1': 'Solar Power',
    'projects.eco.feature2': 'Rainwater Harvesting',
    'projects.eco.feature3': 'Community Gardens',
    'projects.eco.feature4': 'Electric Vehicle Charging',
  },
  ar: {
    // Main projects page
    'projects.title': 'مشاريعنا',
    'projects.subtitle': 'استكشف محفظة مشاريع البناء الناجحة التي تعرض خبرتنا والالتزام بالتميز.',
    
    // Search and filters
    'projects.search.placeholder': 'البحث في المشاريع...',
    'projects.filters.all': 'جميع المشاريع',
    'projects.filters.allSectors': 'جميع القطاعات',
    'projects.filters.allCities': 'جميع المدن',
    'projects.filters.allYears': 'جميع السنوات',
    'projects.filters.commercial': 'تجاري',
    'projects.filters.entertainment': 'ترفيهي',
    'projects.filters.hotel': 'فندقي',
    'projects.filters.industrial': 'صناعي',
    'projects.filters.residential': 'سكني',
    'projects.filters.education': 'تعليمي',
    'projects.filters.utilities': 'مرافق عامة',
    'projects.filters.warehouse': 'مستودعات',
    'projects.filters.infrastructure': 'بنية تحتية',
    'projects.filters.renovation': 'تجديد',
    'projects.filters.active': 'نشط',
    'projects.filters.planning': 'تخطيط',
    'projects.filters.completed': 'مكتمل',
    'projects.filters.onHold': 'معلق',
    
    // Cities
    'projects.cities.jeddah': 'جدة',
    'projects.cities.makkah': 'مكة',
    'projects.cities.jizan': 'جيزان',
    'projects.cities.taif': 'الطائف',
    'projects.cities.alUla': 'العلا',
    'projects.cities.khobar': 'الخبر',
    'projects.cities.alAhsa': 'الأحساء',
    'projects.cities.dammam': 'الدمام',
    'projects.cities.neom': 'نيوم',
    'projects.cities.madinah': 'المدينة المنورة',
    'projects.cities.hael': 'حائل',
    'projects.cities.kaec': 'مدينة الملك عبدالله الاقتصادية',
    'projects.cities.wadiAlDawaser': 'وادي الدواسر',
    'projects.cities.yanbu': 'ينبع',
    'projects.cities.riyadh': 'الرياض',
    
    // Status
    'projects.status.active': 'نشط',
    'projects.status.planning': 'تخطيط',
    'projects.status.completed': 'مكتمل',
    'projects.status.on-hold': 'معلق',
    
    // Form
    'projects.form.selectCity': 'اختر المدينة',
    'projects.form.selectSector': 'اختر القطاع',
    'projects.form.selectStatus': 'اختر الحالة',
    'projects.form.selectYear': 'اختر السنة',
    'projects.form.selectScopeOfWork': 'اختر نطاق العمل',
    'projects.form.scopeOfWork': 'نطاق العمل',
    'projects.form.progress': 'التقدم',
    'projects.form.placeholder.progress': 'أدخل نسبة التقدم (0-100)',
    'projects.form.projectName': 'اسم المشروع',
    'projects.form.projectNameAr': 'اسم المشروع (عربي)',
    'projects.form.placeholder.projectName': 'أدخل اسم المشروع',
    'projects.form.placeholder.projectNameAr': 'أدخل اسم المشروع',
    
    // SEO Fields
    'projects.form.slug': 'رابط URL',
    'projects.form.placeholder.slug': 'project-url-slug',
    'projects.form.metaTitle': 'عنوان SEO',
    'projects.form.metaTitleAr': 'عنوان SEO (عربي)',
    'projects.form.placeholder.metaTitle': 'أدخل عنوان SEO (حد أقصى 60 حرف)',
    'projects.form.placeholder.metaTitleAr': 'أدخل عنوان SEO (حد أقصى 60 حرف)',
    'projects.form.metaDescription': 'وصف SEO',
    'projects.form.metaDescriptionAr': 'وصف SEO (عربي)',
    'projects.form.placeholder.metaDescription': 'أدخل وصف SEO (حد أقصى 160 حرف)',
    'projects.form.placeholder.metaDescriptionAr': 'أدخل وصف SEO (حد أقصى 160 حرف)',
    'projects.form.metaKeywords': 'كلمات SEO المفتاحية',
    'projects.form.metaKeywordsAr': 'كلمات SEO المفتاحية (عربي)',
    'projects.form.placeholder.metaKeywords': 'أدخل الكلمات المفتاحية مفصولة بفواصل',
    'projects.form.placeholder.metaKeywordsAr': 'أدخل الكلمات المفتاحية مفصولة بفواصل',
    
    // Scope of Work
    'projects.scope.mepWorks': 'أعمال الميكانيكية والكهربائية',
    'projects.scope.civilMepWorks': 'أعمال مدنية وميكانيكية وكهربائية',
    
    // Table headers
    'projects.table.progress': 'التقدم',
    'projects.table.scopeOfWork': 'نطاق العمل',
    'projects.table.featuredPhoto': 'الصورة المميزة',
    'projects.table.actions': 'الإجراءات',
    
    // Dashboard stats
    'dashboard.activeProjects': 'المشاريع النشطة',
    'dashboard.completedProjects': 'المشاريع المكتملة',
    
    // Project labels
    'projects.labels.location': 'الموقع',
    'projects.labels.size': 'الحجم',
    'projects.labels.value': 'القيمة',
    'projects.labels.keyFeatures': 'الميزات الرئيسية',
    'projects.viewDetails': 'عرض التفاصيل',
    
    // No results
    'projects.noResults.title': 'لم يتم العثور على مشاريع',
    'projects.noResults.message': 'حاول تعديل معايير البحث أو المرشحات للعثور على المزيد من المشاريع.',
    'projects.noResults.clearFilters': 'مسح جميع المرشحات',
    
    // Stats section
    'projects.stats.title': 'إحصائيات المشاريع',
    'projects.stats.subtitle': 'سجلنا يتحدث عن نفسه',
    'projects.stats.completed': 'مشاريع مكتملة',
    'projects.stats.value': 'القيمة الإجمالية',
    'projects.stats.satisfaction': 'رضا العملاء',
    'projects.stats.experience': 'سنوات الخبرة',
    
    // CTA section
    'projects.cta.title': 'مستعد لبدء مشروعك؟',
    'projects.cta.subtitle': 'دعنا نناقش كيف يمكننا تحقيق رؤيتك بنفس الجودة والخبرة الموضحة في محفظتنا.',
    'projects.cta.button1': 'احصل على عرض سعر مجاني',
    'projects.cta.button2': 'اتصل بنا',
    
    // Downtown Office Complex
    'projects.downtown.title': 'مجمع المكاتب في وسط المدينة',
    'projects.downtown.description': 'مبنى مكتبي حديث من ٢٥ طابق مع تصميم مستدام وتكنولوجيا المباني الذكية.',
    'projects.downtown.location': 'منطقة الأعمال في وسط المدينة',
    'projects.downtown.feature1': 'معتمد LEED ذهبي',
    'projects.downtown.feature2': 'أنظمة المباني الذكية',
    'projects.downtown.feature3': 'تصميم السقف الأخضر',
    'projects.downtown.feature4': 'أمان متقدم',
    
    // Luxury Residential Tower
    'projects.luxury.title': 'برج السكن الفاخر',
    'projects.luxury.description': 'تطوير سكني فاخر من ٤٠ طابق مع وسائل راحة عالمية المستوى وإطلالات مذهلة.',
    'projects.luxury.location': 'منطقة الواجهة البحرية',
    'projects.luxury.feature1': 'جناح بنتهاوس',
    'projects.luxury.feature2': 'مسبح على السطح',
    'projects.luxury.feature3': 'خدمة الكونسيرج',
    'projects.luxury.feature4': 'حدائق خاصة',
    
    // Highway Bridge Project
    'projects.bridge.title': 'مشروع جسر الطريق السريع',
    'projects.bridge.description': 'مشروع بنية تحتية رئيسي يربط طريقين سريعين رئيسيين مع حلول هندسية مبتكرة.',
    'projects.bridge.location': 'المنطقة الحضرية',
    'projects.bridge.feature1': 'هندسة متقدمة',
    'projects.bridge.feature2': 'مقاوم للزلازل',
    'projects.bridge.feature3': 'أنظمة مرور ذكية',
    'projects.bridge.feature4': 'تأثير بيئي',
    
    // Historic Building Renovation
    'projects.historic.title': 'تجديد المبنى التاريخي',
    'projects.historic.description': 'الحفاظ على مبنى تاريخي عمره قرن وتحديثه للاستخدام المعاصر.',
    'projects.historic.location': 'المنطقة التاريخية',
    'projects.historic.feature1': 'الحفاظ على التراث',
    'projects.historic.feature2': 'وسائل راحة حديثة',
    'projects.historic.feature3': 'كفاءة الطاقة',
    'projects.historic.feature4': 'مركز ثقافي',
    
    // Shopping Mall Development
    'projects.shopping.title': 'تطوير مركز التسوق',
    'projects.shopping.description': 'مجمع تجاري كبير مع مرافق ترفيهية وتجربة تسوق حديثة.',
    'projects.shopping.location': 'المنطقة الضواحي',
    'projects.shopping.feature1': 'تصميم متعدد المستويات',
    'projects.shopping.feature2': 'منطقة الترفيه',
    'projects.shopping.feature3': 'محكمة الطعام',
    'projects.shopping.feature4': 'مجمع وقوف السيارات',
    
    // Eco-Friendly Community
    'projects.eco.title': 'مجتمع صديق للبيئة',
    'projects.eco.description': 'مجتمع سكني مستدام مع ممارسات بناء خضراء وأنظمة طاقة متجددة.',
    'projects.eco.location': 'الوادي الأخضر',
    'projects.eco.feature1': 'الطاقة الشمسية',
    'projects.eco.feature2': 'حصاد مياه الأمطار',
    'projects.eco.feature3': 'حدائق المجتمع',
    'projects.eco.feature4': 'شحن السيارات الكهربائية',
  }
};
